import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked"
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"
import {Button} from "@mui/material"
import {styled} from "@mui/material/styles"
import React from "react"
import {LOGO_BLUE, LOGO_BLUE_DARK, NAVY} from "theme"

// Reusable single-select option card (G15 pattern): a radio indicator on the
// left, filled Logo Blue with white text when selected. Shared by the
// select-one screens (Application Status, Medical Practitioner, ...).
const CardButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "selected"
})<{selected: boolean}>(({selected}) => ({
  borderRadius: "17px",
  minHeight: "70px",
  fontSize: "20px",
  justifyContent: "flex-start",
  paddingLeft: "20px",
  textAlign: "left",
  textTransform: "none",
  color: selected ? "#FFFFFF" : NAVY,
  backgroundColor: selected ? LOGO_BLUE : "#FFFFFF",
  border: selected ? `2px solid ${LOGO_BLUE}` : "1px solid #707070",
  ":hover": {
    backgroundColor: selected ? LOGO_BLUE_DARK : "#F5F5F5",
    border: selected ? `2px solid ${LOGO_BLUE}` : `1px solid ${LOGO_BLUE}`
  }
}))

interface AnswerCardProps {
  label: string
  selected: boolean
  onClick: () => void
  fontSize?: string
}

export const AnswerCard: React.FC<AnswerCardProps> = (
  props: AnswerCardProps
) => {
  const {label, selected, onClick, fontSize} = props
  return (
    <CardButton
      selected={selected}
      onClick={onClick}
      fullWidth
      sx={fontSize ? {fontSize} : undefined}
      startIcon={
        selected ? (
          <RadioButtonCheckedIcon
            sx={{fontSize: "32px !important", color: "#FFFFFF"}}
          />
        ) : (
          <RadioButtonUncheckedIcon
            sx={{fontSize: "32px !important", color: "#707070"}}
          />
        )
      }
    >
      {label}
    </CardButton>
  )
}

export default AnswerCard
